import { StyledComponent } from '@emotion/styled';
import { Tooltip, TooltipProps } from '@mui/material';
import { SxProps, Theme } from '@mui/material/styles';
import { styled } from '@mui/material/styles';
import { Colors } from '../../../constants/colors.constants';
import { clsx } from '../../../utils/clsx';

interface OffsetProps {
	placement: NonNullable<TooltipProps['placement']>;
	placementOffset?: [number, number];
}
interface CoreTooltipProps extends TooltipProps {
	tooltipSx?: SxProps<Theme>;
	arrowSx?: SxProps<Theme>;
	dark?: boolean;
	placementOffset?: [number, number];
}

const modifiers = (placementOffset?: [number, number]) => [
	{
		name: 'offset',
		options: {
			offset: ({ placement }: OffsetProps) => {
				if (placement === 'top-start' && placementOffset) {
					return placementOffset;
				}

				if (placement === 'top-start') {
					return [-16, -15];
				}

				if (placement === 'top-end') {
					return [16, -15];
				}

				if (placement === 'bottom-start') {
					return [-10, 0];
				}

				return [];
			},
		},
	},
];

export const CoreTooltip: StyledComponent<CoreTooltipProps> = styled(
	({ className, tooltipSx, arrowSx, placementOffset, dark, ...props }: CoreTooltipProps) => (
		<Tooltip
			{...props}
			enterTouchDelay={0}
			onClick={e => {
				e.stopPropagation();
				e.preventDefault();
			}}
			classes={{ popper: className }}
			PopperProps={{ modifiers: modifiers(placementOffset) }}
		/>
	)
)(({ theme, tooltipSx, arrowSx, dark }) => ({
	color: Colors['white_a10'],
	transition: theme.transitions.create('color', {
		duration: theme.transitions.duration.short,
	}),

	'&:hover': {
		cursor: 'default',
		color: Colors.dark,
	},

	'& .MuiTooltip-arrow:before': clsx(
		{
			color: dark ? Colors['222222'] : Colors.white,
			boxShadow: dark ? 'none' : `0px 0px 4px 0px #9EA3A980`,
		},
		arrowSx
	),

	'& .MuiTooltip-tooltip': clsx(
		{
			// ...theme.typography.label,
			maxWidth: '273px',
			fontSize: '14px',
			fontFamily: 'Montserrat, sans-serif',
			lineHeight: '17px',
			fontWeight: '600',
			textAlign: 'center',
			p: {
				display: 'inline',
				font: 'inherit',
				fontWeight: '500',
			},
			borderRadius: '8px',
			borderTop: `1px solid ${Colors['343434']}`,
			borderLeft: `1px solid ${Colors['343434']}`,
			borderRight: `1px solid ${Colors['343434']}`,
			color: dark ? Colors.white : Colors.dark,
			padding: '12px',
			boxShadow: `0px 6px 11.3px 0px ${dark ? Colors.black_a20 : '#9EA3A980'}`,
			backgroundColor: dark ? Colors['2A2A2A'] : Colors.white,
		},
		tooltipSx
	),
}));
